import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import {
	Component,
	inject,
	signal,
	TemplateRef,
	WritableSignal,
} from '@angular/core';
import {
	ModalDismissReasons,
	NgbAccordionModule,
	NgbDropdownModule,
	NgbModal,
	NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';
import { ExportMultipleArticlesModalComponent } from '../export-multiple-articles-modal/export-multiple-articles-modal.component';
import { FileUploadModalComponent } from '../file-upload-modal/file-upload-modal.component';

import { FormsModule } from '@angular/forms';
import {
	DynamicModalWrapperService,
	PDFArticle,
} from '@meta-press/shared-plugins';
import { Article } from '@meta-press/shared-plugins';
import { MediaViewerComponent } from '../media-viewer/media-viewer.component';
import { NotificationService } from '../notification-service/notification.service';
import { ArticleSearchListComponent } from '../article-search-list/article-search-list.component';
import { SourceMaterialService } from '../source-material-service/source-material.service';
import { AiService } from '../services/ai/ai.service';
import { LoginService } from '../login-service/login.service';
import { NodeEditorComponent } from '../node-editor/node-editor.component';
import { NodeEditorService } from '../node-editor/node-editor.service';
import { TagManagementModalComponent } from '../tag-management-modal/tag-management-modal.component';
import { AddTagsModalComponent } from '../add-tags-modal/add-tags-modal.component';
import { BackendService } from '../backend-service/backend.service';
import { BatchGenerationService } from '../services/batch-generation.service';

@Component({
	selector: 'app-article-library',
	standalone: true,
	imports: [
		NgbNavModule,
		AsyncPipe,
		CommonModule,
		FormsModule,
		NgbDropdownModule,
		NgbAccordionModule,
		ArticleSearchListComponent,
	],
	templateUrl: './article-library.component.html',
	styleUrl: './article-library.component.scss',
})
export class ArticleLibraryComponent {
	active = 1;

	private modalService = inject(NgbModal);
	closeResult: WritableSignal<string> = signal('');

	selectedView: 'tags' | 'articles' = 'articles';

	public OpenNodeEditor(): void {
		const modalRef = this.dynamicModalWrapperService.openComponentModal(
			NodeEditorComponent,
			{
				size: 'lg',
				scrollable: true,
				windowClass: 'modal-xxl',
			},
		);

		// Pass the current game data to the node editor
		if (modalRef && modalRef.componentInstance) {
			// modalRef.componentInstance.rootGameData = this.currentGameData;
			// modalRef.componentInstance.rootPluginType = this.currentPluginType;
		}

		// // Catch received gamedata
		// modalRef.closed.subscribe((result: GameEditor) => {
		// 	if (result) {
		// 		this.articleConceptRequest = result;
		// 	} else {
		// 		console.log(
		// 			'Modal closed without selection or there was no game data',
		// 		);
		// 	}
		// });
	}

	open(content: TemplateRef<any>) {
		this.modalService
			.open(content, {
				ariaLabelledBy: 'modal-basic-title',
				windowClass: 'modal-xxl',
			})
			.result.then(
				(result) => {
					this.closeResult.set(`Closed with: ${result}`);
				},
				(reason) => {
					this.closeResult.set(
						`Dismissed ${this.getDismissReason(reason)}`,
					);
				},
			);
	}

	protected EditArticle(article: Article) {
		// If it's of type "text", use router to go to ['article-editor']
		switch (article.type) {
			case 'text':
				if (article) {
					this.router.navigate(['/article-library/article-editor']);
				} else {
					console.error('No article selected');
				}
				break;
			case 'audio':
			case 'video':
				this.openMedia(article);
				break;
			case 'image':
			case 'pdf':
				{
					// Open the PDF in a new browser window
					const pdfArticle = article as PDFArticle;
					switch (pdfArticle.sourceType) {
						case 'local':
							{
								// Open the local PDF in a new window
								window.open(pdfArticle.localPath, '_blank');
							}
							break;
						case 'url':
							{
								// Open the URL in a new window
								window.open(pdfArticle.url, '_blank');
							}
							break;
					}
				}
				break;

			default:
				console.error(
					'No editor implementation for article type ' + article.type,
				);
				break;
		}
	}

	// Find all tags from all articles

	openMedia(file: Article) {
		if (file.type === 'video' || file.type === 'audio') {
			this.modalService.open(MediaViewerComponent, { size: 'lg' });
		}
	}

	private getDismissReason(reason: any): string {
		switch (reason) {
			case ModalDismissReasons.ESC:
				return 'by pressing ESC';
			case ModalDismissReasons.BACKDROP_CLICK:
				return 'by clicking on a backdrop';
			default:
				return `with: ${reason}`;
		}
	}

	// NEWS_ARTICLES: Article[] = [];
	protected myArticlesSearch = '';
	protected otherArticlesSearch = '';

	// Tags as small caps
	protected mySelectedTags: string[] = [];

	protected otherSelectedTags: string[] = [];

	public ToggleTag(tag: string, target: 'mine' | 'other'): void {
		const searchString = {
			mine: this.myArticlesSearch,
			other: this.otherArticlesSearch,
		};

		if (searchString[target].includes('#' + tag)) {
			searchString[target] = searchString[target].replace('#' + tag, '');
		} else {
			if (searchString[target].length > 0) {
				searchString[target] += ' ';
			}

			searchString[target] += '#' + tag;
		}

		switch (target) {
			case 'mine':
				this.myArticlesSearch = searchString[target];
				break;
			case 'other':
				this.otherArticlesSearch = searchString[target];
				break;
		}
	}

	// public ToggleOtherTag(tag: string): void {
	// 	this.otherSelectedTags = this.ToggleTag(this.otherSelectedTags, tag);
	// }

	// public ToggleTag(sourceTags: string[], tag: string): string[] {
	// 	if (sourceTags.includes(tag.toLowerCase())) {
	// 		return sourceTags.filter((t) => t.toLowerCase() != tag.toLowerCase());
	// 	} else {
	// 		sourceTags.push(tag.toLowerCase());
	// 		return sourceTags;
	// 	}
	// }

	public IsTagSelected(searchString: string, tag: string): boolean {
		const tags: string[] = searchString
			.split(' ')
			.map((t) => t.toLowerCase());

		return tags.some((t) => t == '#' + tag.toLowerCase());
	}

	protected GetSearchFieldTags(searchString: string): string[] {
		return searchString
			.split(' ')
			.filter((t) => t.startsWith('#') && t.length > 1)
			.map((t) => t.substring(1))
			.map((t) => t.toLowerCase());
	}

	// protected SearchArticles(
	// 	sourceArticles: Article[],
	// 	searchWord: string,
	// 	owner: 'me' | 'other' | 'any',
	// ): Article[] {
	// 	// For tag search, split search words into tags
	// 	const tagsInSearchField: string[] = this.GetSearchFieldTags(searchWord);

	// 	const tagIdsInSearchField: number[] =
	// 		this.sourceMaterialService.GetTagIdsByNames(tagsInSearchField);
	// 	const searchWordsInSearchField: string[] = searchWord
	// 		.split(' ')
	// 		.filter((word) => !word.startsWith('#'));

	// 	return sourceArticles.filter((article) => {
	// 		const isOwnerMatch =
	// 			owner == 'any' ||
	// 			(owner == 'me' && article.isMine) ||
	// 			(owner == 'other' && !article.isMine);
	// 		const isTitleMatch = searchWordsInSearchField.every(
	// 			(word) =>
	// 				article.title.toLowerCase().indexOf(word.toLowerCase()) >
	// 				-1,
	// 		);

	// 		const isContentMatch = searchWordsInSearchField.every(
	// 			(word) =>
	// 				article.content.toLowerCase().indexOf(word.toLowerCase()) >
	// 				-1,
	// 		);

	// 		const hasTagMatch =
	// 			tagsInSearchField.length == 0 ||
	// 			article.HasAnyTag(tagIdsInSearchField);

	// 		return (
	// 			isOwnerMatch &&
	// 			(isTitleMatch ||
	// 				isContentMatch ||
	// 				searchWordsInSearchField.length == 0) &&
	// 			hasTagMatch
	// 		);
	// 	});
	// }

	constructor(
		protected sourceMaterialService: SourceMaterialService,
		private router: Router,
		private aiService: AiService,
		protected loginService: LoginService,
		private notificationService: NotificationService,
		private dynamicModalWrapperService: DynamicModalWrapperService,
		protected nodeEditorService: NodeEditorService,
		private backendService: BackendService,
		protected batchGenerationService: BatchGenerationService,
	) {}

	/**
	 * Check if there are active batch jobs (queued or processing)
	 */
	get hasActiveBatchJobs(): boolean {
		const activeBatchJobsCount =
			this.batchGenerationService.getJobCount('queued') +
			this.batchGenerationService.getJobCount('processing');
		return activeBatchJobsCount > 0;
	}

	protected SelectAll(articles: Article[]): void {
		// If all the articles are selected, remove the selection
		// Go through all articles and check if they are selected
		const allSelected = articles.every((article) => {
			return this.sourceMaterialService.IsSelected(article);
		});
		if (allSelected) {
			this.sourceMaterialService.ClearSelection();
		} else {
			// Select all articles
			this.sourceMaterialService.Select(articles, false, false);
		}
	}

	protected Select(
		article: Article[],
		removePreviousSelection: boolean,
		list: 'mine' | 'others',
		allowToggle = true,
	): void {
		// If there's a search filter on, we want to do the selection from clean slate so that no hidden items remain selected.
		switch (list) {
			case 'mine':
				if (this.myArticlesSearch != '') {
					this.sourceMaterialService.ClearSelection();
				}
				break;

			case 'others':
				if (this.otherArticlesSearch != '') {
					this.sourceMaterialService.ClearSelection();
				}
				break;
		}

		this.sourceMaterialService.Select(
			article,
			removePreviousSelection,
			allowToggle,
		);
	}

	protected handleSelectArticles(
		event: { articles: Article[]; removePrevious: boolean },
		list: 'mine' | 'others',
	): void {
		this.Select(event.articles, event.removePrevious, list, true);
	}

	protected handleSelectedArticlesChange(selectedArticles: Article[]): void {
		// Immediately sync the selection with the service
		this.sourceMaterialService.ClearSelection();
		this.sourceMaterialService.Select(selectedArticles, true, false);
	}

	protected handleSearchTextChange(
		text: string,
		target: 'mine' | 'other',
	): void {
		if (target === 'mine') {
			this.myArticlesSearch = text;
		} else {
			this.otherArticlesSearch = text;
		}
	}

	protected OpenExportModal(): void {
		const modalRef = this.modalService.open(
			ExportMultipleArticlesModalComponent,
			{
				fullscreen: false,
				windowClass: 'dark-modal modal-xxl',
				size: 'xl',
			},
		);

		// modalRef.componentInstance.articleConceptRequest = articleConceptRequest;
	}

	protected StartArticlesExport(): void {
		this.OpenExportModal();
	}

	public openFileUploadModal(): void {
		const modalRef = this.modalService.open(FileUploadModalComponent, {
			fullscreen: false,
			size: 'lg',
			backdrop: 'static',
			keyboard: false,
		});
	}

	// Tag management methods
	onAddTagsToSelected(articles: Article[]): void {
		const modalRef = this.modalService.open(AddTagsModalComponent, {
			backdrop: 'static',
			keyboard: false,
		});

		modalRef.componentInstance.selectedArticles = articles;
	}

	onManageTags(): void {
		// Open tag management modal
		this.modalService.open(TagManagementModalComponent, {
			size: 'lg',
			backdrop: 'static',
			keyboard: false,
		});
	}

	onOpenFileSettings(article: Article): void {
		// Open file settings modal using the existing AddTagsModalComponent
		const modalRef = this.modalService.open(AddTagsModalComponent, {
			backdrop: 'static',
			keyboard: false,
		});

		modalRef.componentInstance.selectedArticles = [article];
	}
}
